import React, { useState, useEffect } from "react";
import i18next from "i18next";
import OrderType from "./OrderType";
import { ChevronRight, Download } from "react-feather";
import PropTypes from "prop-types";
import { ContactNotification } from "./ContactNotification";
import moment from "moment";
import { formatPrice } from "~/assets/js/Format";
import Button from "../Button";

const MAX_ITEMS_DISLAYED = 4;

const OrderCard = ({ order, isOngoing = false, handleClick }) => {
    const [state, setState] = useState({
        deliveryDay: "",
        timeSlot: "",
        items: undefined,
    });

    const isPickup = order.dispatch_type === "pickup";

    useEffect(() => {
        const getDeliveryDay = () => {
            moment.locale("de");
            const deliveryDay = moment(order.slot_begin).format("DD. MMMM");

            return deliveryDay;
        };
        const getTimeSlot = () => {
            const slotBegin = moment(order.slot_begin).format("HH:mm");
            const slotEnd = moment(order.slot_end).format("HH:mm");

            return `${slotBegin} - ${slotEnd} Uhr`;
        };

        const filterItems = () => {
            let displayOverlay = false;
            let itemsOverLimit = 0;
            let { items } = order;
            const numberOfItems = items.length;

            if (numberOfItems > MAX_ITEMS_DISLAYED) {
                displayOverlay = true;
                itemsOverLimit = numberOfItems - MAX_ITEMS_DISLAYED;
                items.length = MAX_ITEMS_DISLAYED;
            }

            return {
                items: items,
                displayOverlay: displayOverlay,
                itemsOverLimit: itemsOverLimit,
            };
        };

        setState({
            deliveryDay: getDeliveryDay(),
            timeSlot: getTimeSlot(),
            items: filterItems(),
        });
    }, []);

    const renderOverlay = (productIndex) => {
        const itemsOverhead = state.items.itemsOverLimit;
        if (productIndex === state.items.items.length - 1) {
            return (
                <div className="order-card_items_img_container_overlay">
                    <p className="order-card_items_img_container_overlay_number">
                        {`+${itemsOverhead}`}
                    </p>
                </div>
            );
        }
    };

    return (
        <>
            <div className="order-card">
                <button className="order-card__top" onClick={handleClick}>
                    <div className="order-card_heading">
                        <div className="order-card_heading_text">
                            <p className="order-card_heading_text_day">
                                {state.deliveryDay}
                            </p>
                            <p className="order-card_heading_text_time-slot">
                                {state.timeSlot}
                            </p>
                        </div>
                        <div className="order-card_heading_order-type">
                            <p>
                                {isPickup
                                    ? i18next.t("delivery.pickup")
                                    : i18next.t("delivery.delivery")}
                            </p>
                        </div>
                    </div>

                    <OrderType
                        order={order}
                        isPickup={isPickup}
                        storeId={order.store_id}
                    />

                    <div className="order-card_items">
                        {!!state.items &&
                            state.items.items.map((item, index) => {
                                return (
                                    <div
                                        key={`o-${order.uid}__i-${item.product_id}`}
                                        className="order-card_items_img_container">
                                        {state.items.displayOverlay &&
                                            renderOverlay(index)}
                                        <img
                                            className="order-card_items_img"
                                            src={item.thumbnail_url}
                                            key={item.product_id}
                                        />
                                    </div>
                                );
                            })}
                    </div>

                    {/* TODO What is day_uid*/}
                    <div className="order-card__order-number-container">
                        {order.day_uid && (
                            <span className="order-card_order-number">{`${i18next.t(
                                `orderConfirmation.${
                                    isPickup
                                        ? "pickupMessage"
                                        : "deliveryMessage"
                                }.orderNumber`
                            )} ${order.day_uid}`}</span>
                        )}
                    </div>
                </button>

                {isOngoing && <ContactNotification storeId={order.store_id} />}

                {/* TODO get value_gross from BE*/}
                <div className="order-card_cta">
                    <p className="order-card_cta_price">
                        {formatPrice(order.value_gross)}
                    </p>
                    {!order.invoice_url ? (
                        <div
                            className="order-card_cta_button"
                            onClick={handleClick}>
                            <p>
                                {i18next.t(
                                    "customerArea.ordersOverview.viewOrder"
                                )}
                            </p>
                            <ChevronRight size={24} />
                        </div>
                    ) : (
                        <Button
                            variant="secondary"
                            label={i18next.t(
                                "customerArea.ordersOverview.downloadReceipt"
                            )}
                            icon={<Download />}
                            href={order.invoice_url}
                            customStyle="order-detail_actions_button"
                            size="XS"
                        />
                    )}
                </div>
            </div>
        </>
    );
};

OrderCard.propTypes = {
    order: PropTypes.object.isRequired,
    handleClick: PropTypes.func.isRequired,
    isOngoing: PropTypes.bool,
};

export default OrderCard;
